import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9592a94"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Регистрация", -1))

import {ref} from 'vue'
    import ButtonCustom from '../UI/ButtonCustom.vue';
    import { useNotification } from "@kyvg/vue3-notification";
    import { useStore } from 'vuex';
    import handleError from '@/tools/errorHandler'
    import {API} from '@/api/modules/auth'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'RegistrationModule',
  emits: ['close'],
  setup(__props, { emit }) {

    const store = useStore()
    const { notify }  = useNotification()

    let mail = ref('')
    let login = ref('')
    let password = ref('')
    let rePassword = ref('')

    

    function registration(){
        if(password.value != rePassword.value){
            notify({
                group: 'notification',
                title: `Пароли не совпадают`,
                text: ``,
                type: "warn",
                duration: 500,
                closeOnClick: true,
            });
            password.value = ''
            rePassword.value = ''
            return
        }

        API.registration(login.value, password.value, mail.value)
            .then( res => {
                // console.log(res.data.token)

                store.commit('setUserName', login.value)
                store.commit('setToken', res.data.token)
                emit('close')
            })
            .catch(err => handleError(err))
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _withDirectives(_createElementVNode("input", {
      class: "auth-input",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(mail) ? (mail).value = $event : mail = $event)),
      placeholder: "Электронная почта"
    }, null, 512), [
      [_vModelText, _unref(mail)]
    ]),
    _withDirectives(_createElementVNode("input", {
      class: "auth-input",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(login) ? (login).value = $event : login = $event)),
      placeholder: "Логин"
    }, null, 512), [
      [_vModelText, _unref(login)]
    ]),
    _withDirectives(_createElementVNode("input", {
      class: "auth-input",
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(password) ? (password).value = $event : password = $event)),
      placeholder: "Пароль",
      type: "password"
    }, null, 512), [
      [_vModelText, _unref(password)]
    ]),
    _withDirectives(_createElementVNode("input", {
      class: "auth-input",
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(rePassword) ? (rePassword).value = $event : rePassword = $event)),
      placeholder: "Повторите пароль",
      type: "password"
    }, null, 512), [
      [_vModelText, _unref(rePassword)]
    ]),
    _createVNode(ButtonCustom, {
      onClick: _cache[4] || (_cache[4] = ($event: any) => (registration()))
    }, {
      default: _withCtx(() => [
        _createTextVNode("Зарегестрироваться")
      ]),
      _: 1
    }),
    _createElementVNode("p", null, [
      _createTextVNode("Перейти на "),
      _createElementVNode("span", {
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('toggle-auth')))
      }, "вход")
    ])
  ]))
}
}

})